import PaperBox from "../PaperBox/PaperBox";
import ToggleItemWithTooltip from "../ToggleItem/ToggleItemWithTooltip";

interface ToggleSwitchPaperBoxProps {
  title: string;
  onToggleSwitch: (() => void) | undefined;
  isChecked: boolean | undefined;
  tooltip?: string;
  isDisabled?: boolean;
  customIconStyle?: {};
}

const ToggleSwitchPaperBox = ({
  title,
  onToggleSwitch,
  isChecked,
  tooltip,
  isDisabled,
  customIconStyle
}: ToggleSwitchPaperBoxProps) => {
  return (
    <PaperBox
      customStyling={{ padding: "0 16px", margin: "16px 0" }}
      testId="global-schedule-inheritance-switch"
      noBottomPadding
    >
      <ToggleItemWithTooltip
        title={title}
        tooltipText={tooltip}
        onToggle={onToggleSwitch}
        isChecked={isChecked || false}
        isDisabled={isDisabled}
        customIconStyle={customIconStyle}
        customSwitchStyle={{
          marginLeft: "30px"
        }}
      />
    </PaperBox>
  );
};

export default ToggleSwitchPaperBox;
